import React from 'react';
import { Box, BoxProps } from '@apia/theme';
import { useTreeContext } from './TreeContext';
import TreeItem from './TreeItem';
import { TDataNode } from './types';

const TreeItemChildren = React.forwardRef<
  HTMLDivElement,
  {
    forceUpdate: number;
    level: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodes: TDataNode<any>[];
  } & BoxProps
>(({ level, nodes, forceUpdate, ...props }, ref) => {
  const { handler } = useTreeContext();

  return (
    <Box ref={ref} as="ul" {...props}>
      {nodes?.map((current) => {
        const currentProps = handler.propsStore.getFieldProps(current.id);
        if (!currentProps) return null;

        return currentProps.isFiltered ? null : (
          <TreeItem level={level + 1} key={current.id} treeKey={current.id} />
        );
      })}
    </Box>
  );
});

export default React.memo(TreeItemChildren);
